"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _utils = require("../utils");

var _shared = require("./shared");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var buttonReset = (0, _styledComponents.css)(["background-color:transparent;padding:0;margin:0;color:inherit;border:none;font:inherit;line-height:normal;overflow:visible;-webkit-font-smoothing:inherit;-moz-osx-font-smoothing:inherit;-webkit-appearance:none;"]);

var Button = _styledComponents["default"].button.withConfig({
  shouldForwardProp: _shared.shouldForwardProp
}).withConfig({
  displayName: "button__Button",
  componentId: "sc-1f4p0t3-0"
})(["", ";", ";"], buttonReset, _shared.defaultSystemProps);

var propTypes = {
  // Font size css style system prop
  fontSize: _utils.stylePropType,
  // Polymorphic prop that determines what's ultimately being rendered
  tag: _propTypes.elementType
};
Button.propTypes = propTypes;
Button.displayName = "Primitives.Button";
var _default = Button;
exports["default"] = _default;